import * as React from "react";
import "./Icon.css";

const SvgUStorageIcon = ({
  color1 = "#000",
  color2 = "#cf4a9b",
  width,
  height,
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 47.96 47.96"
    width={width || undefined}
    height={height ? height : "auto"}
    {...props}
    className={`svg-icon large shake-two-icon-target ${props.className || ""}`}
    style={{
      transformOrigin: "center",
      ...props.style,
      ...(width ? { width: width } : {}),
      ...(height ? { height: height } : {}),
    }}
  >
    <g transform="translate(0,6)">
      <path
        d="M33.76 5.93h8.82a1.61 1.61 0 0 0 1.64-1.59V2A1.61 1.61 0 0 0 42.58.38h-8.82A10.49 10.49 0 0 0 23.1 10.7 10.49 10.49 0 0 0 33.76 21h3a4.77 4.77 0 1 1 0 9.54h-8l2.76 5.56h5.29a10.5 10.5 0 0 0 10.57-10.3 10.51 10.51 0 0 0-10.67-10.33h-3a4.84 4.84 0 0 1-4.92-4.77 4.85 4.85 0 0 1 4.97-4.77"
        style={{
          fill: color1,
          stroke: color1,
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: ".75px",
        }}
      />
      <path
        d="M25.37.69V.38h-5.11v7.24A11 11 0 0 1 25.37.69M24.79 28.22a11.1 11.1 0 0 0 .57-3.42h0v-4.46a10.9 10.9 0 0 1-5.11-6.91v11.21A6.38 6.38 0 0 1 13.88 31h-2a6.39 6.39 0 0 1-6.39-6.38V.38H.38v24.26a11.48 11.48 0 0 0 11.49 11.49h2a11.42 11.42 0 0 0 7-2.4l1.45 2.4h6.18Z"
        style={{
          fill: color2,
          stroke: color2,
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: ".75px",
        }}
      />
    </g>
  </svg>
);

export default SvgUStorageIcon;
